import { useEffect } from 'react';
import { useAuth } from './AuthContext';
import pushNotifications from '../../services/pushNotifications';

export default function PushNotificationLifecycle() {
  const { user, isAuthenticated, isLoading } = useAuth();
  const userId = user?.id || user?.userId;
  const companyId = user?.company?.id;
  const enabled = user?.isEnabled;

  useEffect(() => {
    if (!isLoading) void pushNotifications.setAccount(isAuthenticated ? user : null);
  }, [isLoading, isAuthenticated, userId, companyId, enabled]);

  useEffect(() => {
    const reconcile = () => { void pushNotifications.reconcile(); };
    const onVisibility = () => { if (document.visibilityState === 'visible') reconcile(); };
    const onMessage = (event) => {
      if (event.data?.type === 'CLAW_PUSH_SUBSCRIPTION_CHANGED') reconcile();
    };
    window.addEventListener('focus', reconcile);
    window.addEventListener('online', reconcile);
    document.addEventListener('visibilitychange', onVisibility);
    navigator.serviceWorker?.addEventListener('message', onMessage);
    return () => {
      window.removeEventListener('focus', reconcile);
      window.removeEventListener('online', reconcile);
      document.removeEventListener('visibilitychange', onVisibility);
      navigator.serviceWorker?.removeEventListener('message', onMessage);
    };
  }, []);

  return null;
}
